module.exports = __webpack_public_path__ + "img/4.89a48652.jpg";